<div
    class="navbar-header"
    *ngIf="!fuseConfig.layout.navbar.hideHeader"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
>
    <!-- [matMenuTriggerFor]="userMenu" -->
    <div
        class="cursor-pointer"
        fxLayout="row"
        fxLayoutAlign="center center"
        (click)="navRoute('profile')"
    >
        <div
            class="mr-12 cus-avatar h-44 w-44"
            *ngIf="userInfo && userInfo.ProfileImageUrl"
        >
            <img src="{{ userInfo.ProfileImageUrl }}" alt='Profile'/>
        </div>

        <div
            class="mr-12 cus-avatar"
            *ngIf="userInfo && !userInfo.ProfileImageUrl"
        >
            <ngx-avatars
                [round]="true"
                size="40"
                textSizeRatio="2.5"
                name="{{ userInfo.DisplayName }}"
                value="{{ userInfo.DisplayName }}"
                bgColor="{{ userInfo.ColorCode }}"
                fgColor="#FFFFFF"
                initialsSize="1"
                class="my-avatar"
            >
            </ngx-avatars>
        </div>
        <div>
            <p
                *ngIf="fuseConfig.layout.navbar.userNameShow"
                class="username p-0 line-height-18 m-0 text-truncate w-96"
            >
                {{ userInfo.DisplayName || 'USER NAME' }}
            </p>
            <!-- <p *ngIf="userInfo.Designation && fuseConfig.layout.navbar.designationShow"
            class="designation font-size-12 p-0 m-0 line-height-12 text-truncate w-96">
            {{userInfo.Designation}}</p> -->
        </div>
    </div>

    <mat-menu class="profile-menu" #userMenu="matMenu" [overlapTrigger]="false">
        <button
            *ngFor="
                let menuItem of fuseConfig.layout.navbar.topMenu.newMenuList
            "
            mat-menu-item
            (click)="customMenuClickEvent(menuItem)"
        >
            <mat-icon>{{ menuItem.icon }}</mat-icon>
            <span>{{ menuItem.title | translate }}</span>
        </button>
        <!--         <button
            *ngIf="fuseConfig.layout.navbar.topMenu.showMyAccount"
            mat-menu-item
            (click)="openMyAccountDialog()"
        >
            <mat-icon>account_circle</mat-icon>
            <span>{{ 'NAVBAR.MY_ACCOUNT' | translate }}</span>
        </button>
        <button
            *ngIf="fuseConfig.layout.navbar.topMenu.showAbout"
            mat-menu-item
            (click)="openDialog()"
        >
            <mat-icon>info</mat-icon>
            <span>{{ 'NAVBAR.ABOUT' | translate }}</span>
        </button>
        <button
            *ngIf="
                fuseConfig.layout.navbar.topMenu.showMemory &&
                showReportIssueMenu
            "
            mat-menu-item
            class=""
            (click)="openReportDialog()"
        >
            <mat-icon>memory</mat-icon>
            <span>{{ 'NAVBAR.REPORT_ISSUE' | translate }}</span>
        </button>
        <button
            *ngIf="fuseConfig.layout.navbar.topMenu.showLogout"
            mat-menu-item
            class=""
            (click)="logout()"
        >
            <mat-icon>{{
                fuseConfig.layout.navbar.topMenu.logoutIcon
            }}</mat-icon>
            <span>{{ 'NAVBAR.LOGOUT' | translate }}</span>
        </button> -->
    </mat-menu>

    <!-- <button
        mat-icon-button
        class="toggle-sidebar-folded"
        (click)="toggleSidebarFolded()"
        fxHide.lt-lg
    >
        <mat-icon>menu</mat-icon>
    </button> -->

    <button
        mat-icon-button
        class="toggle-sidebar-opened"
        (click)="toggleSidebarOpened()"
        fxHide.gt-md
    >
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>

<div
    class="navbar-content"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground"
>
    <fuse-navigation
        layout="vertical"
        [navigation]="navigation"
    ></fuse-navigation>

    <div
        *ngIf="fuseConfig.layout.navbar.hideHeader"
        fxLayoutAlign="center center"
    >
        <button
            mat-raised-button
            class="mt-24 toggle-sidebar-opened"
            (click)="toggleSidebarOpened()"
        >
            <mat-icon class="primary-text-color mb-4">arrow_back</mat-icon>
        </button>
    </div>
</div>
<!-- <form [hidden]="true" #authFormLogout method="post" action="">
  <input type="hidden" name="Landing_Uri" value="">
  <input type="hidden" value="" name="Logged_Off_SSO_Domains">
</form> -->
